import otmService from '@/services/otmService';
import { captureMessage, captureException } from '@sentry/browser';
import { generateUUID } from '@/helpers/Util';
import { getHostname, formatUrl } from '@/helpers/Url';
import { MAX_RESULTS, BLACKLSITED_DOMAINS } from '@/config/constants';
import parallel from 'async/parallel';

export default {

  fetchKeywordResults({ commit }, { keyword, domain }) {
    return new Promise(async (resolve, reject) => {
      commit('fetchingKeywordResults', keyword)
      
      try {
        const response = await otmService.fetchKeywordResults(keyword)
    
        const { results } = response.data
    
        let keywordResults = results.organic
        .filter( r => !BLACKLSITED_DOMAINS.includes(getHostname(r.result_url)) && r !== null)
        .map( r => {
          return {
            uuid: generateUUID(),
            id: r.post_id,
            key: r.post_key,
            position: r.result_position,
            clean_domain: getHostname(r.result_url),
            url: r.result_url,
            host: formatUrl(r.result_url),
          }
        });
    
        const domainResultInTop100 = keywordResults.filter(d => d.host === domain)[0];
        
        keywordResults = keywordResults.slice(0,MAX_RESULTS)
    
        const domainInMaxResults = keywordResults.slice(0,MAX_RESULTS).filter(d => d.host === domain)[0]
    
        // If Domain in max range, just splice the array
        if(!domainInMaxResults && domainResultInTop100)
          keywordResults.push(domainResultInTop100)
    
        else if (!domainInMaxResults && !domainResultInTop100) {
          keywordResults.push({
            uuid: generateUUID(),
            id:keyword,
            key: keyword,
            position: '100+',
            clean_domain: domain,
            url: getHostname(domain),
          });
        }
        
        commit('fetchingKeywordResultsSuccess', keyword)
        commit('updateResults', {[keyword]: keywordResults})
    
        resolve(keywordResults);

      } catch (error) {
        const { code, message } = error.response.data;
        
        captureMessage(message);
        
        reject({ message, status: code });
      }

    })
  },

  async fetchSingleResultData({ commit }, { url, item }) {
    console.log({ url, item })
    commit('removeAdditionalResultErrorStatus', item.uuid);
    
    commit('fetchingAdditionalResult', item.uuid);
    
    try {
      
      const { data } = await otmService.keywordSummary({ keyword: item.key, url, uuid: item.uuid});

      commit('updateAdditionalResults', { [item.uuid]: { ...data } });
      
      commit('removeAdditionalResultFetchingStatus', item.uuid);

    } catch (error) {
      
      captureException(error)
      
      commit('fetchingAdditionalResultError', item.uuid);
      
      commit('removeAdditionalResultFetchingStatus', item.uuid);
    }
  },

  async fetchResultsData({ commit }, results) {
    
    let asyncFunctions = {};

    results.forEach( d => {


      asyncFunctions = {
        ...asyncFunctions,
        [d.uuid]: async (callback) => {
          try {
            commit('fetchingAdditionalResult', d.uuid);
            const { data } = await otmService.keywordSummary({ keyword: d.key, url: d.url, uuid: d.uuid});

            commit('updateAdditionalResults', { [d.uuid]: { ...data } });
            
            commit('removeAdditionalResultFetchingStatus', d.uuid);

            callback(null, data)
          } catch (error) {
            
            captureException(error);

            commit('fetchingAdditionalResultError', d.uuid);
            
            commit('removeAdditionalResultFetchingStatus', d.uuid);
            
            callback(null, null)
          }
        }
      }
    })

    parallel(asyncFunctions, () => {})
  },

  async fetchSummary({ commit }, keyword) {

    commit('fetchingKeyword', keyword)

    try {
      const response = await otmService.keywordStats({ keyword })
  
      const { data } = response
      
      commit('updateKeyword', { ...data, keyword })
      commit('fetchingKeywordSuccess', keyword)
      
    } catch (error) {
      captureException(error);
    }

  },

  updateSelectedKeyword: async ({ commit }, method) => {
    commit('updateSelectedKeyword', method)
  },

  updateKeywords({ commit }, method) {
    const keys = Object.keys(method)

    keys.map(key => {
      commit('updateKeywords', { [method[key]]: { key, keyword: method[key] } })
    })
  },

  updateKeyword({ commit }, method) {
    commit('updateKeyword', method)
  }, 

  removeKeyword({ commit }, method) {
    commit('removeKeyword', method)
  }, 
}